import React from "react";
import "./KeyChip.css";

function KeyChip({ children, label, className = "" }) {
    const keys = String(children).split(/\s*\+\s*/);
    return (
        <span className={`key-chip ${className}`} aria-label={label || keys.join(" then ")}>
            {keys.map((k, i) => (
                <React.Fragment key={i}>
                    <kbd className="key-chip__key">{k}</kbd>
                    {i < keys.length - 1 && (
                        <span className="key-chip__sep" aria-hidden="true">
                            +
                        </span>
                    )}
                </React.Fragment>
            ))}
        </span>
    );
}

export default KeyChip;
